import { Component, OnInit, Input } from '@angular/core';
import { SharedHandlersService } from '../../../shared/shared-handlers.service';
import '@progress/kendo-angular-intl/locales/ar/all';
@Component({
    selector: 'app-linegraph',
    templateUrl: './linegraph.component.html',
    styleUrls: ['./linegraph.component.scss']
})
export class LinegraphComponent implements OnInit {
    //graph properties
    @Input() ctrMetaData: any;
    
    //data
   @Input() defaultValue: any;
    @Input() Categories: any[];
    @Input() Data: any[] = [[100, 123, 234, 343], [120, 67, 231, 196], [45, 124, 189, 143], [87, 154, 210, 215]];//bar
    @Input() data: any[]; //[{ kind: 'Acheived', share: this.defaultValue, colorField: "#d7481f" }, { kind: '', share: 23, colorField: "white" }];//donut
    @Input() newstyle:string;
    @Input()holeSize : number;
    @Input()chartLegendStyle:string;
    //variables
    public GraphType: string;
    public GraphTitle: string;
    public WithLabel: boolean = true;
    public LegendLabel: boolean = true;
    public style: string = 'normal';
    public zoomRate = 0.3;
    public color ; 
    constructor(public Shared: SharedHandlersService) { 
        this.holeSize=70
        this.style = 'normal';
    }

    ngOnInit() {
        this.GraphType = this.ctrMetaData["DataType"];
        this.GraphTitle = this.Shared.getName(this.ctrMetaData["Name"]);
        this.color = getComputedStyle(document.documentElement).getPropertyValue('--primaryColor');
}

}
